import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";
import { useOfferMode } from "@nju/data-access-portal-offers";
import { Icon } from "@nju/icons";
import { portalRoutes } from "@nju/routes";
import { A, BlockText, Panel, Separator } from "@nju/ui";
import { Marker } from "./Marker";

export interface ICreditCardPaymentBannerProps {
  isActive: boolean;
  cardNumber: string;
  changePaymentMethodUrl?: LinkProps["href"];
  cardId: string;
  userId: string | undefined;
}

export function CreditCardPaymentBanner({
  isActive,
  cardNumber,
  changePaymentMethodUrl,
  cardId,
  userId,
}: ICreditCardPaymentBannerProps) {
  const router = useRouter();
  const mode = useOfferMode();
  const isReactivationProcess = portalRoutes.mojeKonto.platnosci.index.hasParam(
    router.query,
    "procesReaktywacji",
  );
  const isChangePaymentProcess =
    portalRoutes.mojeKonto.platnosci.index.hasParam(
      router.query,
      "zmianaMetodyPlatnosci",
    );

  return (
    <Panel
      border={isActive ? "info" : "default"}
      testId="credit-card-payment-banner"
    >
      <div className="h-full flex flex-col">
        <div className="flex items-center	justify-between">
          <Marker isActive={isActive} url={changePaymentMethodUrl} />
          <Icon height={35} name="credit-card" width={40} />
        </div>
        <Separator size="s" tone="invisible" />
        <BlockText size={{ "@onlyMobile": "m", "@fromTablet": "xl" }}>
          numer karty
        </BlockText>
        <Separator size="xs" tone="invisible" />
        <BlockText size="keyS">*** **** **** {cardNumber}</BlockText>
        <Separator size="s" tone="invisible" />
        <div className="mt-auto">
          <Link
            href={portalRoutes.mojeKonto.platnosci.zarzadzajKarta.get({
              id: cardId,
              ...(userId && { userId }),
              ...(isReactivationProcess && { procesReaktywacji: "1", mode }),
              ...(isChangePaymentProcess && {
                zmianaMetodyPlatnosci: "1",
                mode,
              }),
            })}
            passHref={true}
          >
            <A size={{ "@onlyMobile": "s" }} variant="secondary">
              zarządzaj kartą
            </A>
          </Link>
        </div>
      </div>
    </Panel>
  );
}
